import React from 'react';
import { CheckCircle, XCircle, AlertCircle, Clock } from 'lucide-react';
import { classNames } from '../../utils/classNames';

interface StatusIndicatorProps {
  status: 'success' | 'error' | 'warning' | 'loading';
  message?: string;
  className?: string;
}

const statusConfig = {
  success: {
    icon: CheckCircle,
    color: 'text-green-500',
    bgColor: 'bg-green-100',
    borderColor: 'border-green-500/30',
  },
  error: {
    icon: XCircle,
    color: 'text-red-500',
    bgColor: 'bg-red-100',
    borderColor: 'border-red-500/30',
  },
  warning: {
    icon: AlertCircle,
    color: 'text-yellow-500',
    bgColor: 'bg-yellow-100',
    borderColor: 'border-yellow-500/30',
  },
  loading: {
    icon: Clock,
    color: 'text-blue-500',
    bgColor: 'bg-blue-100',
    borderColor: 'border-blue-500/30',
  },
};

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({
  status,
  message,
  className = ''
}) => {
  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <div className={classNames(
      'flex items-center space-x-2 px-3 py-2 rounded-lg border',
      config.bgColor,
      config.borderColor,
      className
    )}>
      <Icon className={classNames('h-4 w-4', config.color)} />
      {message && (
        <span className="text-sm font-medium text-gray-900">{message}</span>
      )}
    </div>
  );
};